@for (group of selectedTimeSlot().groups; track group.name) {
  <sd-item-wrapper (click)="onSelectGroup(group.name)" [isActive]="group.name === selectedGroupName()">
    <!-- todo: добавить вывод стоимости (после того как будет понятно откуда его брать) -->
    {{ group.name }}
  </sd-item-wrapper>
}
